<template>
  <div class="page-module-wrap">
    本地开发时,请手动编辑添加Session12
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="less">
  .page-module-wrap {
    text-align: center;
    font-size: 26px;
  }
</style>
